import { useEffect, useState } from "react";
import { useHeaderContext } from "../../context/headerContext"
import { useUserContext } from "../../context/userContext";
import Button from "../../components/Button";
import GuestBandCard from "../../components/GuestBandCard"
import TextInput from "../../components/TextInput";
import fetchWithRefresh from "../../utils/fetchWithRefresh";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";
import { LogErrors } from "../../utils/LogErrors";

export default function GuestBandsDirectory() {
    const { setTitle, setBackButton, setSearchFunc } = useHeaderContext();
    const { user, selectedVenue, logout, updateTokens } = useUserContext();
    const [ guestBands, setGuestBands ] = useState([]);
    const [ filteredGuestBands, setFilteredGuestBands ] = useState([]);
    const [ toggleSearchView, setToggleSearchView ] = useState(false);

    useEffect(() => {
        setTitle("GUEST BANDS");
        setBackButton(true);
        setSearchFunc(() => {
            setToggleSearchView(false);
        });
        //fetchVenueGuestBands();
        localStorage.removeItem("activeGuestBandStep1");
        localStorage.removeItem("activeGuestBandStep2");
        localStorage.removeItem("activeGuestBandStep3");
        localStorage.removeItem("activeGuestBandStep4");
    }, []);

    useEffect(() => {
        if(selectedVenue?.OrgID){
            fetchVenueGuestBands();
        }
    }, [selectedVenue]);

    useEffect(() => {
        if(guestBands.length > 0){
            setFilteredGuestBands(guestBands);
        }
    }, [guestBands]);

    useEffect(() => {
        setSearchFunc(() => {
            setToggleSearchView(!toggleSearchView);
        });
    }, [toggleSearchView]);

    const fetchVenueGuestBands = async () => {
        await Sentry.startSpan({ name: "Fetch Venue Guest Bands", op: "http.request" }, async (span) => {
          try {
            const response = await fetchWithRefresh(
              `${import.meta.env.VITE_API_URL}GuestBands/FetchGuestBandsForVenue?venueId=${selectedVenue.OrgID}&includeUnassigned=0`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${user.token}`,
                },
              },
              logout,
              updateTokens,
              (message) => { toast.info(message); }
            );
      
            span.setAttribute("http.status_code", response.status);
      
            if (response.ok) {
              const data = await response.json();
              setGuestBands(data);
            } else {
              LogErrors(user, logout, updateTokens, "Error fetching guest bands.");
              span.setStatus("error");
            }
          } catch (error) {
            Sentry.captureException(error);
            LogErrors(user, logout, updateTokens, "Error fetching guest bands: " + error);
            span.setStatus("error");
          } finally {
            span.end();
          }
        });
    };      

    const searchGuestBands = (e) => {
        const searchTerm = e.target.value.toLowerCase();

        const filteredBands = guestBands?.filter(band => 
            band?.FriendlyName.toLowerCase().includes(searchTerm) ||
            band?.ParticipantName.toLowerCase().includes(searchTerm)
        );

        setFilteredGuestBands(filteredBands);
    }

    return (
        <div className="flex flex-col gap-10">
            {toggleSearchView && (
                <div className="absolute top-0 left-0 w-full bg-white p-6">
                    <TextInput
                        label={"Search"}
                        name={"SearchGuestBands"}
                        onChange={(e) => searchGuestBands(e)}
                    />
                </div>
            )}
            <div>
              <p className="text-[12px] font-semibold leading-6 spacing tracking-[0.2em] mb-1 uppercase">{selectedVenue?.OrgPartnerFriendlyName}</p>
              <h2>Guest Bands</h2>
            </div>

            <Button href="/guest-bands/scan" className="w-full">Assign New Guest Band</Button>

            <div className="flex flex-col gap-3">
                {filteredGuestBands?.map((band, index) => {
                    return (
                        <GuestBandCard band={band} key={band?.BandID + index}/>
                    )
                })}
            </div>
        </div>
    )
}